import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * ApiUrlService constructs full API URLs by combining base URLs and endpoint paths
 * defined in the environment configuration. Useful for managing multiple backend services.
 */
@Injectable({ providedIn: 'root' })
export class ApiUrlService {

 getUrl(
  serviceKey: keyof typeof environment.apiBaseUrls,
  endpointKey: keyof typeof environment.apiEndpoints,
  pathParams: Record<string, string> = {},
  queryString: string = ''
): string {
  const base = environment.apiBaseUrls?.[serviceKey];
  let path = environment.apiEndpoints?.[endpointKey];

  if (!base || !path) {
    throw new Error(
      `Missing base URL or endpoint for keys: ${String(serviceKey)}, ${String(endpointKey)}`
    );
  }

  // Replace :param placeholders with actual values
  Object.entries(pathParams).forEach(([key, value]) => {
    path = path.replace(`:${key}`, encodeURIComponent(value));
  });
  let url = `${base}${path}`;
  if (queryString) {
    url += `?${queryString}`;
  }
  return url;
}

}
